<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col
        v-for="symposia in simposiums"
        v-bind:key="symposia.name"
        cols="12"
        md="4"
      >
        <SymposiaCard :symposia="symposia"></SymposiaCard>
      </v-col>
      <v-col>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn rounded x-large v-bind="attrs" v-on="on">
              <v-icon x-large>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">User Profile</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row justify="center" align="center">
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="name"
                      label="name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="acronym"
                      label="acronym"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-color-picker
                      dot-size="25"
                      swatches-max-height="200"
                      v-model="color"
                    ></v-color-picker>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="createSymposio">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createSimposio as createSimposioService } from "@/services/symposiums.js";

import SymposiaCard from "@/components/panel/SymposiaCard";

export default {
  components: {
    SymposiaCard
    //Login
  },
  props: {
    simposiums: {
      type: Array
    }
  },
  data() {
    return {
      dialog: false,
      name: "",
      acronym: "",
      color: ""
    };
  },
  methods: {
    async createSymposio() {
      var data = {
        acronym: this.acronym,
        color: this.color,
        openInscriptions: true,
        name: this.name
      };
      await createSimposioService(data);
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>